<template>
  <div class="container-fluid" id="members_page">
    <div v-if="user_level < 50">
      <h5 class="text-danger text-center mt-5">Access Denied!</h5>
    </div>

    <div v-else>
      <!-- Header -->
      <div class="page-header gold mt-4 mb-3">
        <back-btn></back-btn>
        <h2 class="mb-0">
          <i class="fas fa-users pr-2"></i>
          <span v-text="$route.meta.title"></span>
          <small>({{ totalRows }})</small>
        </h2>
      </div>
      <div v-if="user_level >= 90" class="d-flex justify-content-center flex-wrap mb-3" style="gap: 8px">
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="addMember">
          <i class="fas fa-user-plus"></i> Add New Member
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="downloadAsCSV">
          <i class="fas fa-download"></i> Download CSV
        </button>
      </div>

      <!-- Edit member modal -->
      <b-modal id="modal-profile" :title="modal.title" ref="modal-profile" hide-footer>
        <b-form @submit="submitMemberForm($event)">
          <b-form-group description="Member Status">
            <b-form-select v-model="modal.member.status" :options="options.statuses" @change="validate(modal.member)"></b-form-select>
          </b-form-group>

          <b-form-group description="Member Level">
            <b-form-select v-model="modal.member.level" :options="options.levels" @change="validate(modal.member)"></b-form-select>
          </b-form-group>

          <b-form-group v-if="modal.member.level >= 30">
            <div class="d-flex" style="gap: 6px">
              <label for="coach" class="mb-0">Coach?</label>
              <b-form-checkbox id="coach" v-model="modal.member.is_coach" switch></b-form-checkbox>
            </div>
          </b-form-group>

          <b-form-group description="First Name">
            <small class="text-danger" v-if="modal.member.first_name === ''">Enter a First name</small>
            <b-form-input v-model="modal.member.first_name" type="text" required placeholder="Enter First name" @change="validate(modal.member)"></b-form-input>
          </b-form-group>

          <b-form-group description="Last Name">
            <small class="text-danger" v-if="modal.member.last_name === ''">Enter a Last name</small>
            <b-form-input v-model="modal.member.last_name" type="text" required placeholder="Enter Last name" @change="validate(modal.member)"></b-form-input>
          </b-form-group>

          <b-form-group description="User/Screen Name">
            <small class="text-danger" v-if="modal.member.user_name === ''">Enter a User name</small>
            <b-form-input v-model="modal.member.user_name" type="text" required placeholder="Enter user name" @change="validate(modal.member)"></b-form-input>
          </b-form-group>

          <b-form-group description="Enter a unique Email address">
            <small class="text-danger" v-if="!validEmail(modal.member.email)">Enter an Email</small>
            <b-form-input v-model="modal.member.email" type="email" required placeholder="Enter email" @change="validate(modal.member)"></b-form-input>
          </b-form-group>

          <b-form-group description="* Phone is Optional">
            <b-form-input v-model="modal.member.phone" type="text" placeholder="Enter phone" @change="validate(modal.member)"></b-form-input>
          </b-form-group>

          <p><small class="text-danger" v-text="modal.errors.process"></small></p>
          <div class="row">
            <div class="col text-left">
              <b-button type="submit" variant="success" :disabled="modal.submitDisabled">Submit</b-button>
            </div>
            <div class="col text-right">
              <b-button size="sm" @click="confirmBox" name="delete" variant="outline-danger">Delete</b-button>
            </div>
          </div>
        </b-form>

        <data-streams :profileid="modal.member.id" />
      </b-modal>

      <!-- Filter Bar -->
      <div v-if="members && members.length > 5" class="card mb-3">
        <div class="card-body py-2 px-3">
          <div class="d-flex flex-wrap align-items-end" style="gap: 10px">
            <div style="flex: 2 1 180px; min-width: 160px">
              <label class="small font-weight-bold mb-1">Search</label>
              <b-input-group size="sm">
                <b-form-input v-model="search" type="search" placeholder="Name, email, username..."></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!search" @click="search = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>

            <div style="flex: 1 1 120px; min-width: 110px">
              <label class="small font-weight-bold mb-1">Status</label>
              <b-form-select v-model="filterStatus" :options="filterStatusOptions" size="sm"></b-form-select>
            </div>

            <div style="flex: 1 1 120px; min-width: 110px">
              <label class="small font-weight-bold mb-1">Activity</label>
              <b-form-select v-model="filterActivity" :options="filterActivityOptions" size="sm"></b-form-select>
            </div>

            <div style="flex: 1 1 130px; min-width: 120px">
              <label class="small font-weight-bold mb-1">No Processing in</label>
              <b-form-select v-model="filterNoProcessing" :options="filterDayOptions" size="sm"></b-form-select>
            </div>

            <div style="flex: 1 1 130px; min-width: 120px">
              <label class="small font-weight-bold mb-1">No Meditation in</label>
              <b-form-select v-model="filterNoMeditation" :options="filterDayOptions" size="sm"></b-form-select>
            </div>

            <div style="flex: 1 1 130px; min-width: 120px">
              <label class="small font-weight-bold mb-1">Recently Joined</label>
              <b-form-select v-model="filterRecentlyJoined" :options="filterRecentlyJoinedOptions" size="sm"></b-form-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination controls -->
      <div v-if="totalRows > 5" class="row mb-2">
        <div class="col-md-3 col-5">
          <b-form-select v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
        </div>
        <div class="col-md-9 col-7">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="right"
              size="sm"
              class="my-0"
          ></b-pagination>
        </div>
      </div>

			<!-- Members Table -->
      <div class="members-list-scroll">
        <b-table
          bordered
          :items="filteredMembers"
          :busy="isBusy"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          sort-icon-left
          class="small members-table"
          show-empty
          empty-text="No members match the current filters."
        >
          <template v-slot:table-busy>
            <div class="text-center my-2 p-2">
              <b-spinner class="align-middle"></b-spinner>
              <br /><strong>Loading...</strong>
            </div>
          </template>

          <!-- Actions + activity tag -->
          <template v-slot:cell(full_name)="data">
            <span>{{ data.item.full_name }}</span>
            <div class="d-inline pl-2">
              <b-dropdown size="sm" toggle-class="text-decoration-none border-0 p-0 bg-transparent" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v gold"></i>
                </template>
                <b-dropdown-item
                  v-if="user_level >= 90 && parseInt(user_level) >= parseInt(data.item.level)"
                  @click="editMember($event, data.item)"
                >
                  <i class="fas fa-edit mr-1"></i> Edit Member
                </b-dropdown-item>
                <b-dropdown-item :to="'/member/' + data.item.id + '?from=/members'">
                  <i class="fas fa-user mr-1"></i> View Profile
                </b-dropdown-item>
                <b-dropdown-item :to="'/profile_report/' + data.item.id + '?from=/members'">
                  <i class="fas fa-chart-bar mr-1"></i> View Report
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <!-- Last Activity -->
          <template v-slot:cell(last_activity_at)="data">
            <span v-if="data.item.last_activity_at">{{ formatDate(data.item.last_activity_at) }}</span>
            <span v-else class="text-muted">—</span>
            <span :title="activityLabel(data.item)" class="activity-tag">{{ activityTag(data.item) }}</span>
          </template>

          <!-- Status -->
          <template v-slot:cell(status)="data">
            <span v-text="arrayElmGet(options.statuses, data.item.status)"></span>
          </template>

          <!-- Level -->
          <template v-slot:cell(level)="data">
            <span v-text="arrayElmGet(options.levels, data.item.level)"></span>
          </template>

          <!-- 7-day: Contractions Logged -->
          <template v-slot:cell(c_logged_7d)="data">
            <span v-if="data.item.stats_7d" v-text="data.item.stats_7d.contractions_logged"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- 7-day: Contractions Processed -->
          <template v-slot:cell(c_processed_7d)="data">
            <span v-if="data.item.stats_7d" v-text="data.item.stats_7d.contractions_processed"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- 7-day: Meditation Sessions -->
          <template v-slot:cell(med_sessions_7d)="data">
            <span v-if="data.item.stats_7d" v-text="data.item.stats_7d.meditation_sessions"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- 7-day: Meditation Minutes -->
          <template v-slot:cell(med_time_7d)="data">
            <span v-if="data.item.stats_7d" v-text="data.item.stats_7d.meditation_time_min"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- All-time: Contractions Logged -->
          <template v-slot:cell(c_logged_all)="data">
            <span v-if="data.item.stats_all" v-text="data.item.stats_all.contractions_logged"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- All-time: Contractions Processed -->
          <template v-slot:cell(c_processed_all)="data">
            <span v-if="data.item.stats_all" v-text="data.item.stats_all.contractions_processed"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- All-time: Meditation Sessions -->
          <template v-slot:cell(med_sessions_all)="data">
            <span v-if="data.item.stats_all" v-text="data.item.stats_all.meditation_sessions"></span>
            <span v-else class="text-muted">—</span>
          </template>

          <!-- All-time: Meditation Minutes -->
          <template v-slot:cell(med_time_all)="data">
            <span v-if="data.item.stats_all" v-text="data.item.stats_all.meditation_time_min"></span>
            <span v-else class="text-muted">—</span>
          </template>
        </b-table>
      </div>

      <!-- Bottom pagination -->
      <b-pagination v-if="totalRows > 5"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    class="my-0 mt-2"
      ></b-pagination>

    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import DataStreams from '../components/DataStreams.vue';
import BackBtn from '@/components/BackBtn.vue';

export default {
  name: 'Members',
  components: { DataStreams, BackBtn },
  data() {
    return {
      modal: {
        title: '',
        submitDisabled: true,
        member: {},
        errors: { process: '' },
      },
      modal_member_default: {
        id: 0,
        first_name: '',
        last_name: '',
        user_name: '',
        email: '',
        phone: '',
        status: 1,
        level: 20,
        is_coach: false,
      },
      options: {
        levels: [
          { value: 0, text: 'Pending' },
          { value: 20, text: 'Member' },
          { value: 30, text: 'Team Coach' },
          { value: 50, text: 'Editor' },
          { value: 90, text: 'Admin' },
        ],
        statuses: [
          { value: 0, text: 'Closed' },
          { value: 1, text: 'Active' },
        ],
      },
      members: null,
      fields: [
        { key: 'full_name',       sortable: true,  label: 'Name',                 thStyle: 'min-width: 120px' },
        { key: 'user_name',        sortable: true,  label: 'Username',            thStyle: 'min-width: 130px' },
        { key: 'email',            sortable: true,  label: 'Email',               thStyle: 'min-width: 200px' },
        { key: 'phone',            sortable: true,  label: 'Phone',               thStyle: 'min-width: 120px' },
        { key: 'last_activity_at', sortable: true,  label: 'Last Activity',       thStyle: 'min-width: 140px' },
        { key: 'status',           sortable: true,  label: 'Status',              thStyle: 'min-width: 90px' },
        { key: 'level',            sortable: true,  label: 'Level',               thStyle: 'min-width: 110px' },
        { key: 'c_logged_7d',      sortable: true,  label: 'C. Logged (7d)',      thStyle: 'min-width: 130px' },
        { key: 'c_processed_7d',   sortable: true,  label: 'C. Processed (7d)',   thStyle: 'min-width: 145px' },
        { key: 'med_sessions_7d',  sortable: true,  label: 'Med. Sessions (7d)',  thStyle: 'min-width: 150px' },
        { key: 'med_time_7d',      sortable: true,  label: 'Med. Mins (7d)',      thStyle: 'min-width: 130px' },
        { key: 'c_logged_all',     sortable: true,  label: 'C. Logged (All)',     thStyle: 'min-width: 130px' },
        { key: 'c_processed_all',  sortable: true,  label: 'C. Processed (All)',  thStyle: 'min-width: 150px' },
        { key: 'med_sessions_all', sortable: true,  label: 'Med. Sessions (All)', thStyle: 'min-width: 155px' },
        { key: 'med_time_all',     sortable: true,  label: 'Med. Mins (All)',     thStyle: 'min-width: 135px' },
      ],
      isBusy: true,
      sortBy: 'first_name',
      sortDesc: false,
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 50, text: 'Num to Show' },
        25, 50, 100,
        { value: 500, text: 'All' },
      ],
      // Filters
      search: '',
      filterStatus: 'all',
      filterActivity: 'all',
      filterNoProcessing: '',
      filterNoMeditation: '',
      filterRecentlyJoined: '',
      filterStatusOptions: [
        { value: 'all', text: 'All statuses' },
        { value: 1, text: 'Active' },
        { value: 0, text: 'Inactive' },
      ],
      filterActivityOptions: [
        { value: 'all', text: 'All activity' },
        { value: 'active', text: '🟢 Active' },
        { value: 'low', text: '🟡 Low activity' },
        { value: 'inactive', text: '🔴 Inactive' },
      ],
      filterDayOptions: [
        { value: '', text: 'Any' },
        { value: '7', text: '7 days' },
        { value: '14', text: '14 days' },
        { value: '30', text: '30 days' },
        { value: '60', text: '60 days' },
      ],
      filterRecentlyJoinedOptions: [
        { value: '', text: 'All time' },
        { value: '7', text: 'Last 7 days' },
        { value: '14', text: 'Last 14 days' },
        { value: '30', text: 'Last 30 days' },
        { value: '60', text: 'Last 60 days' },
        { value: '90', text: 'Last 90 days' },
      ],
    };
  },
  computed: {
    active_profile() {
      return this.$store.getters.profileGet;
    },
    user_level() {
      return this.active_profile.level;
    },
    filteredMembers() {
      if (!this.members) return [];
      let result = this.members;

      if (this.search) {
        const q = this.search.toLowerCase();
        result = result.filter(m =>
            (m.first_name || '').toLowerCase().includes(q) ||
            (m.last_name || '').toLowerCase().includes(q) ||
            (m.user_name || '').toLowerCase().includes(q) ||
            (m.email || '').toLowerCase().includes(q)
        );
      }

      if (this.filterStatus !== 'all') {
        result = result.filter(m => parseInt(m.status) === parseInt(this.filterStatus));
      }

      if (this.filterActivity !== 'all') {
        result = result.filter(m => this.activityStatus(m) === this.filterActivity);
      }

      // Filter: no processing in last X days
      if (this.filterNoProcessing) {
        const days = parseInt(this.filterNoProcessing);
        const cutoff = Date.now() - days * 86400000;
        result = result.filter(m => {
          // Prefer dedicated timestamp when available
          if (m.last_contraction_processed_ts) {
            return m.last_contraction_processed_ts * 1000 < cutoff;
          }
          // Fall back to 7d stats for the 7-day option
          if (days === 7 && m.stats_7d !== null) {
            return m.stats_7d.contractions_processed === 0;
          }
          return true;
        });
      }

      // Filter: no meditation in last X days
      if (this.filterNoMeditation) {
        const days = parseInt(this.filterNoMeditation);
        const cutoff = Date.now() - days * 86400000;
        result = result.filter(m => {
          // Prefer dedicated timestamp when available
          if (m.last_meditation_ts) {
            return m.last_meditation_ts * 1000 < cutoff;
          }
          // Fall back to 7d stats for the 7-day option
          if (days === 7 && m.stats_7d !== null) {
            return m.stats_7d.meditation_sessions === 0;
          }
          return true;
        });
      }

      if (this.filterRecentlyJoined) {
        const days = parseInt(this.filterRecentlyJoined);
        const cutoff = Date.now() - days * 86400000;
        result = result.filter(m => m.joined_at && new Date(m.joined_at).getTime() >= cutoff);
      }

      return result;
    },
    totalRows() {
      return this.filteredMembers.length;
    },
  },
  watch: {
    // Reset to page 1 whenever filters change
    search() { this.currentPage = 1; },
    filterStatus() { this.currentPage = 1; },
    filterActivity() { this.currentPage = 1; },
    filterNoProcessing() { this.currentPage = 1; },
    filterNoMeditation() { this.currentPage = 1; },
    filterRecentlyJoined() { this.currentPage = 1; },
  },
  methods: {
    // Activity tag helpers — driven by last_activity_ts (new field) or falls back to last_session
    activityStatus(member) {
      const ts = member.last_activity_at_ts || null;
      if (!ts) return 'inactive';
      const daysSince = (Date.now() - ts * 1000) / 86400000;
      if (daysSince <= 7) return 'active';
      if (daysSince <= 30) return 'low';
      return 'inactive';
    },
    activityTag(member) {
      const s = this.activityStatus(member);
      if (s === 'active') return '🟢';
      if (s === 'low') return '🟡';
      return '🔴';
    },
    activityLabel(member) {
      const s = this.activityStatus(member);
      if (s === 'active') return 'Active – within last 7 days';
      if (s === 'low') return 'Low activity – 8 to 30 days';
      return 'Inactive – over 30 days';
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    arrayElmGet(obj, value) {
      if (parseInt(value) === 99) return 'WebMaster';
      for (const v of Object.values(obj)) {
        if (parseInt(v.value) === parseInt(value)) return v.text;
      }
      return null;
    },
    addMember() {
      this.modal.title = 'Add Member';
      this.modal.member = { ...this.modal_member_default };
      this.modal.errors.process = '';
      this.$bvModal.show('modal-profile');
      this.validate(this.modal.member);
    },
    editMember(e, member) {
      e.preventDefault();
      this.modal.title = 'Edit Profile';
      this.modal.member = member;
      this.modal.errors.process = '';
      this.$bvModal.show('modal-profile');
      this.validate(this.modal.member);
    },
    confirmBox() {
      this.$bvModal
          .msgBoxConfirm('Are you sure? All data will be lost...')
          .then(value => {
            if (value) {
              this.deleteMemberForm();
            } else {
              this.$bvModal.hide('modal-profile');
            }
          })
          .catch(err => console.log(err));
    },
    deleteMemberForm() {
      this.modal.submitDisabled = true;
      this.modal.errors.process = 'Removing Data ...';
      const params = new URLSearchParams();
      params.append('session_id', this.$store.state.session_id);
      params.append('user_id', this.modal.member.id);
      axios({ url: this.$store.state.api_url + 'userDelete', params })
          .then(response => {
            this.modal.errors.process = response.data.message;
            if (response.data.status == 1) {
              this.members = this.members.filter(obj => obj.id !== response.data.user_id);
              this.modal.member = { ...this.modal_member_default };
              this.$bvModal.hide('modal-profile');
            }
          })
          .catch(() => {});
    },
    displayOptionsSet() {
      if (this.user_level == 99) {
        this.options.levels.push({ value: 99, text: 'WebMaster' });
      } else if (this.user_level == 50) {
        this.$route.meta.title = 'Team Members';
        document.title = this.$route.meta.title + ' - iAMconnected App';
      }
    },
    getMembers() {
      axios('membersGet')
          .then(response => {
            this.isBusy = false;
            this.members = response.data.status == 1 ? response.data.members : [];
          })
          .catch(() => {
            console.log('Error: membersGet.');
            this.isBusy = false;
          });
    },
    downloadAsCSV() {
      axios({
        url: `${this.$store.state.api_url}membersCSV`,
        params: { token: this.$store.state.session_id },
      })
          .then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: 'text/csv;charset=utf-8' })
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'members.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(error => console.log(error));
    },
    submitMemberForm(e) {
      e.preventDefault();
      this.validate(this.modal.member);
      this.modal.errors.process = 'Processing...';

      if (this.modal.member.level < 30) {
        this.modal.member.is_coach = false;
      }

      const data = {
        id: this.modal.member.id,
        first_name: this.modal.member.first_name,
        last_name: this.modal.member.last_name,
        user_name: this.modal.member.user_name,
        email: this.modal.member.email,
        phone: this.modal.member.phone,
        status: this.modal.member.status,
        level: this.modal.member.level,
        is_coach: this.modal.member.is_coach,
      }

      axios({
        method: 'post',
        url: 'userAddEdit',
        headers: { 'Content-Type': 'multipart/form-data' },
        data
      })
          .then(response => {
            if (response.data.status == 1) {
              if (response.data.member !== null) {
                if (response.data.type === 'add') {
                  this.members.unshift(response.data.member);
                } else {
                  const idx = this.members.findIndex(obj => obj.id === response.data.member.id);
                  if (idx !== -1) this.$set(this.members, idx, response.data.member);
                }
              }
              this.modal.member = { ...this.modal_member_default };
              this.$bvModal.hide('modal-profile');
            } else {
              this.modal.errors.process = response.data.message;
            }
          })
          .catch(() => {});
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validate(member) {
      let valid = true;
      if (member.status === '' || member.status === 'null') valid = false;
      if (member.level === '' || member.level === 'null') valid = false;
      if (!member.first_name || !member.last_name || !member.user_name) valid = false;
      if (!this.validEmail(member.email)) valid = false;
      this.modal.submitDisabled = !valid;
      return !valid;
    },
  },
  mounted() {
    this.displayOptionsSet();
    this.getMembers();
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  position: relative;
  padding: 0 52px;
}
.page-header h2 {
  min-width: 0;
  text-align: center;
  word-break: break-word;
}
.gold {
  color: #d6b674;
}


.activity-tag {
  font-size: 0.85rem;
  cursor: help;
  padding-left: 4px;
}

.members-table :deep(th),
.members-table :deep(td) {
  white-space: nowrap;
}

.members-list-scroll {
	max-height: 70vh;
	overflow-y: auto;
	overflow-x: auto;
}
</style>
